import { produce } from 'immer';

import { UploadInternalBannerImageByLink } from '../../../actions/imageEditor/internal/uploadInternalBannerImageByLink';
import { getImageEditorIdByBannerId } from '../../../service/ImageHelpers/ImageHelpers';
import { ImageOrCreativeUploadingMode } from '../../../typings/banners';
import { ImageEditorsState } from '../../../typings/state';

export function uploadInternalBannerImageByLink(
    state: ImageEditorsState,
    action: UploadInternalBannerImageByLink
): ImageEditorsState {
    const id = getImageEditorIdByBannerId(action.bannerId, action.resourceId);

    return produce(state, draft => {
        draft[id].image.uploadProgress = 1;
        draft[id].image.mode = ImageOrCreativeUploadingMode.UPLOADING;
        draft[id].image.isUploadByLink = true;
        draft[id].image.errors = undefined;
    });
}
